var map = {
	"./business/business.module": [
		"./src/app/business/business.module.ts",
		"common",
		"business.module"
	],
	"./calendar/calendar.module": [
		"./src/app/calendar/calendar.module.ts",
		"calendar.module"
	],
	"./charts/charts.module": [
		"./src/app/charts/charts.module.ts",
		"charts.module"
	],
	"./crud/crud.module": [
		"./src/app/crud/crud.module.ts",
		"common",
		"crud.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./finances/finances.module": [
		"./src/app/finances/finances.module.ts",
		"common",
		"finances.module"
	],
	"./movement/movement.module": [
		"./src/app/movement/movement.module.ts",
		"common",
		"movement.module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"./stock/stock.module": [
		"./src/app/stock/stock.module.ts",
		"common",
		"stock.module"
	],
	"./timeline/timeline.module": [
		"./src/app/timeline/timeline.module.ts",
		"timeline.module"
	],
	"./userpage/user.module": [
		"./src/app/userpage/user.module.ts",
		"user.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main